import styled from 'styled-components';

const InfoCol = styled.div`
  display: flex;
  label {
    width: 35%;
    color: ${(p) => p.theme.colors.gray200};
  }
  span {
    width: 65%;
  }
`;

const Hr = styled.div`
  width: 1px;
  border-left: 1px solid ${(p) => p.theme.colors.gray100};
  height: 100%;
`

const Notice = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: ${(p) => (p.isTablet ? 'column' : 'row')};
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 15px;
  border-radius: 15px 15px 15px 0px;
  ${(p) => p.theme.outsideShadowW02};
  background: #ffdbdb;

  > .text {
    display: inline-block;
    margin-left: ${(p) => (p.isTablet ? '0' : '20px')};
  }

  > a {
    width: ${(p) => (p.isTablet ? '100%' : 'unset')};
    margin-left: ${(p) => (p.isTablet ? '0' : 'auto')};

    > button {
      width: ${(p) => (p.isTablet ? '100%' : '150px')};
      padding: 10px 0;
      text-align: center;
      background: ${(p) => p.theme.colors.primary500};
      border-radius: 5px;
      color: ${(p) => p.theme.colors.light};
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: ${(p) => p.theme.fontSizes.base};
      line-height: 19px;
      text-decoration: none;
    }
  }
`;

const Icons = styled.span`
  display: flex;
  gap: 3px;
`;

export { InfoCol, Hr, Notice, Icons };
